'use client'

import { useMemo, useState, useTransition } from 'react'
import { AchieveLink } from '@/components/AchieveLink'
import Section from '@/components/Section'
import { Typography } from '@/components/Contentful'
import { formatPublishDate } from 'utils/conversions/dates'
import { Grid, Pagination } from '@achieve/ascend'
import { useAppRouter } from '@/hooks/useAppRouter/useAppRouter'
import AchieveSkeleton from '@/components/AchieveSkeleton/AchieveSkeleton'

function PaginatedBillsAuthorArticlesList({ listArticles, pageLimit, totalArticles }) {
  const { query, replace, asPath } = useAppRouter()
  const [isLoading, startTransition] = useTransition()
  const [page, setPage] = useState(query ? query.page : 1)

  const articleItems = useMemo(() => {
    const articleItems = []
    for (let i = 0; i < listArticles?.length; i++) {
      const item = listArticles[i]
      articleItems.push(
        <Grid key={item?.slug} size={{ xs: 12 }}>
          <div className="flex flex-col">
            <AchieveLink href={`/${item?.slug}`} className="text-[#083289]">
              <Typography content={item?.title} className="headingSm text-[#083289]" />
            </AchieveLink>
            <div className="flex flex-row gap-2 text-gray-800">
              <Typography content={formatPublishDate(item?.publishDate)} className="bodyXs" />
            </div>
            <Typography content={item?.metaDescription} className="bodySm mt-4" />
          </div>
        </Grid>
      )
    }
    return articleItems
  }, [listArticles])

  const handleChangePage = (event, page) => {
    const params = new URLSearchParams(query)
    if (page) params.set('page', page)

    startTransition(() => {
      setPage(page)
      replace(`${asPath}?${params.toString()}`)
    })
  }

  // const handleChangePage = (_, page) => {
  //   const params = new URLSearchParams(query)
  //   if (page) params.set('page', page)
  //   replace(`${asPath}?${params.toString()}`)
  // }

  if (listArticles.length === 0) {
    return null
  }

  return (
    <Section className={'overflow-hidden lg:[overflow:initial]'}>
      {isLoading && (
        <Grid container spacing={4} marginTop={1} marginBottom={3}>
          {Array.from({ length: pageLimit }).map((_, index) => (
            <Grid size={{ xs: 12 }} key={`skeleton-${index}`}>
              <AchieveSkeleton width="100%" height="100px" />
            </Grid>
          ))}
        </Grid>
      )}
      {!isLoading && (
        <Grid container spacing={4} marginTop={1} marginBottom={3}>
          {articleItems}
        </Grid>
      )}
      {parseInt(totalArticles ?? '0') / pageLimit > 1 && (
        <Grid item className="flex justify-center my-6">
          <Pagination
            color="primary"
            className="flex justify-center"
            data-testid="press-grid-pagination"
            count={Math.ceil(parseInt(totalArticles ?? '0') / pageLimit)}
            onChange={handleChangePage}
            page={page ? parseInt(page) : 1}
          />
        </Grid>
      )}
    </Section>
  )
}

export default PaginatedBillsAuthorArticlesList
